import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function NotAuthorized() {
    const navigate = useNavigate()

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            px: 2
        }}>
            <Typography variant="h4" sx={{ mb: 2 }}>
                Creator Access Required
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '600px' }}>
                This area is reserved for creators who build predictive models. If you're interested in becoming a creator, 
                please contact us to learn more about our creator program.
            </Typography>
            <Button 
                variant="contained" 
                onClick={() => navigate('/login')}
                sx={{ mt: 2 }}
            >
                Return to Home
            </Button>
        </Box>
    )
}
